"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationPaymentMethodResponseDto = exports.DeleteOrganizationPaymentMethodResponse = exports.GetOrganizationPaymentMethodDto = exports.OrganizationPaymentMethodDto = exports.RemoveOrganizationPaymentMethodDto = void 0;
class RemoveOrganizationPaymentMethodDto {
}
exports.RemoveOrganizationPaymentMethodDto = RemoveOrganizationPaymentMethodDto;
class OrganizationPaymentMethodDto {
}
exports.OrganizationPaymentMethodDto = OrganizationPaymentMethodDto;
class GetOrganizationPaymentMethodDto {
}
exports.GetOrganizationPaymentMethodDto = GetOrganizationPaymentMethodDto;
class DeleteOrganizationPaymentMethodResponse {
}
exports.DeleteOrganizationPaymentMethodResponse = DeleteOrganizationPaymentMethodResponse;
class OrganizationPaymentMethodResponseDto extends OrganizationPaymentMethodDto {
}
exports.OrganizationPaymentMethodResponseDto = OrganizationPaymentMethodResponseDto;
//# sourceMappingURL=organization-payment-method.dto.js.map